<template>
  <div class="mixin-sample">
    <div>Window width: {{ windowWidth }}</div>
    <div>Window height: {{ windowHeight }}</div>
  </div>
</template>

<script>
import Vue from 'vue'
import { windowSize } from '@/lib/WindowSizeMixin'

export default {
  name: 'MixinSample',
  setup() {
    const { height: windowHeight, width: windowWidth } = windowSize()

    return {
      windowHeight,
      windowWidth
    }
  }
}
</script>
